import { apiRoot } from '../apiInstances';
import type { KBSuggestion } from '../../utils/suggestionToLineItem';

export type { KBSuggestion };

export const knowledgeBaseApi = {
  suggest: async (year: number, make: string, model: string): Promise<KBSuggestion[]> => {
    const { data } = await apiRoot.get('/knowledge-base/suggestions', {
      params: { year, make, model },
    });
    return data as KBSuggestion[];
  },
};
